import { useState, useEffect } from "react";
import "../../OperationMasterPages/OrderList/OrderList.css";
import React from "react";
import { useNavigate } from "react-router-dom";
import MiniDrawer from "../../../components/MiniDrawer/MiniDrawer";
import axios from "axios";
import Wrapper from "../../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import Loader from "../../../components/Loader/loader";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css";
import CryptoJS from "crypto-js";
import search from "../../../images/Search.png";
import searchIcon from "../../../images/SearchIcon.png";
import MailIcon from "@mui/icons-material/Mail";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Tooltip from '@mui/material/Tooltip';

const OrderList = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showTooltip1, setShowTooltip1] = useState(false);

  const [dateRange, setDateRange] = useState("Custom Dates");
  const togglePicker = () => {
    setDateRange(
      formatDate(selectionRange.startDate) +
      " - " +
      formatDate(selectionRange.endDate)
    );
    setIsOpen(!isOpen);
  };
  const [userDetailResponse, setUserDetailResponse] = useState(null);
  const [openAddProfile, setOpenAddProfile] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate(); // State for the Navigation list
  const [assignToResponse, setAssignToResponse] = useState([]);
  const [assignFieldResponse, setAssignFieldResponse] = useState([]);

  const [assignedto, setAssignedto] = useState("0");
  const [assignedfieldto, setAssignedtoField] = useState("0");
  const [searchKeyword, setSearchKeyword] = useState("");
  const [isAvailable, setIsAvailable] = useState(false);

  const [availableClass, setAvailableClass] = useState("unavailable");

  const [totalPages, setTotalPages] = useState();
  const [totalRecords, setTotalRecords] = useState(0);

  const [pageSize, setPageSize] = useState(50);
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [filterdata, setFilterdata] = useState("");
  const [statusColor, setStatusColor] = useState("#28A745");
  const [leadtype, setLeadtype] = useState("");
  const [leadSource, setLeadSource] = useState("0");
  const [assignedtoLO, setAssignedtoLO] = useState("0");
  const [assignToLOResponse, setAssignToLOResponse] = useState([]);
  const [mailSent, setMailSent] = useState(() => {
    const savedMailSent = JSON.parse(localStorage.getItem("mailSent"));
    return savedMailSent || [];
  });
  const [serviceType, setServiceType] = useState("0");
  const [serviceTypeResponse, setServiceTypeResponse] = useState([]);
  const isAdmin = localStorage.getItem("isAdmin");
  const baseAPI = process.env.REACT_APP_API_URL;


  // function getStatusColor(statusName) {
  //   switch (statusName) {
  //     case "NA":
  //       return "orange";
  //     case "Confirmed":
  //       return "#20BF44";
  //     case "Pending":
  //       return "#5B489D";
  //     default:
  //       return "white";
  //   }
  // }

  function encryptRelocationID(Relocation_ID, key) {
    const ciphertext = CryptoJS.AES.encrypt(
      Relocation_ID.toString(),
      key
    ).toString();
    return encodeURIComponent(ciphertext);
  }

  function encryptEmailID(email, key) {
    const ciphertext = CryptoJS.AES.encrypt(
      email.toString(),
      key
    ).toString();
    return encodeURIComponent(ciphertext);
  }

  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }
  const handleSelect = (ranges) => {
    // ranges contains an object with startDate and endDate
    setSelectionRange(ranges.selection);
  };

  function getStatusColor(statusName) {
    switch (statusName) {
      case 'Untouched':
        return 'orange';
      case 'Open':
        return '#28A745';
      case 'Executed':
        return '#DC3545';
      case 'Cancelled':
        return '#87CEEB';
      case 'Abandoned':
        return '#cccfd8';
      default:
        return 'white';
    }
  }



  useEffect(() => {
    getEmployeeByDepartment();
    getFieldEmployeeByDepartment();
    getEmployeeByDepartmentSales();
    getServiceType();
    const storedToken = JSON.parse(localStorage.getItem("token"));
    let opt = 1;
    if (filterdata) {
      opt = filterdata;
    }

    let startdate = formatDate(selectionRange.startDate);
    let enddate = formatDate(selectionRange.endDate);
    if (dateRange === "Custom Dates") {
      startdate = "";
      enddate = "";
    }

    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetOperationOrderList?pageNumber=${currentPage}&pageSize=${pageSize}&option=${opt}&searchParam=${searchKeyword}&searchOps=${assignedto}&searchFieldOps=${assignedfieldto}&leadSource=${leadSource}&leadregion=${leadtype}&startDate=${startdate}&enddate=${enddate}&assignedtoLO=${assignedtoLO}&serviceType=${serviceType}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          if (response) {
            setUserDetailResponse(response.data.data);
            setTotalPages(response.data.totalPages);
            setTotalRecords(response.data.totalRecords);
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        })
        .finally(() => {
          setLoading(false); // Set loading to false when data is fetched
        });

      axios
        .get(`${baseAPI}userget/GetAvailibility`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          //console.log(response.data.data);
          setIsAvailable(response.data.data[0].is_available);
          {
            response.data.data[0].is_available
              ? setAvailableClass("available")
              : setAvailableClass("unavailable");
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, [currentPage]);

  useEffect(() => {
    localStorage.setItem("mailSent", JSON.stringify(mailSent));
  }, [mailSent]);

  function getEmployeeByDepartment() {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(`${baseAPI}adminget/GETEmployeeByDepartment?department_id=9`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        setAssignToResponse(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  function getFieldEmployeeByDepartment() {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(`${baseAPI}adminget/GETEmployeeByDepartment?department_id=12`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        setAssignFieldResponse(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  function getLeadListButton() {
    if (isOpen) {
      setDateRange(
        formatDate(selectionRange.startDate) +
        " - " +
        formatDate(selectionRange.endDate)
      );
      setIsOpen(!isOpen);
    }
    setCurrentPage(1);
    if (!filterdata) {
      setFilterdata("1", () => {
        getLeadList("1"); // Ensure getorderlist is called after state update
      });
    } else {
      getLeadList(filterdata);
    }
  }

  function clearFilter() {
    setCurrentPage(1);
    setDateRange("Custom Dates");
    setSearchKeyword("");
    setAssignedto("0");
    setAssignedtoField("0");
    setLeadSource("0");
    setLeadtype("");
    setFilterdata("1");
    getLeadList("1");
    setAssignedtoLO('0');
    setServiceType("0");
  }

  const clearDateRange = () => {
    setSelectionRange({
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    });
  };

  function getLeadList(filterdata) {
    setLoading(true);
    const storedToken = JSON.parse(localStorage.getItem("token"));
    let startdate = formatDate(selectionRange.startDate);
    let enddate = formatDate(selectionRange.endDate);
    if (dateRange === "Custom Dates") {
      startdate = "";
      enddate = "";
    }

    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetOperationOrderList?pageNumber=${currentPage}&pageSize=${pageSize}&option=${filterdata}&searchParam=${searchKeyword}&searchOps=${assignedto}&searchFieldOps=${assignedfieldto}&leadSource=${leadSource}&leadregion=${leadtype}&startDate=${startdate}&enddate=${enddate}&assignedtoLO=${assignedtoLO}&serviceType=${serviceType}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          if (response) {
            setUserDetailResponse(response.data.data);
            setTotalPages(response.data.totalPages);
            setTotalRecords(response.data.totalRecords);
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        })
        .finally(() => {
          setLoading(false); // Set loading to false when data is fetched
        });
    }
  }

  const handleChange = (e) => {
    setFilterdata(e.target.value);
  };

  const handleSearchChange = (e) => {
    setSearchKeyword(e.target.value);
  };

  const handleAssignChange = (e) => {
    setAssignedto(e.target.value);
  };
  const handleAssignField = (e) => {
    setAssignedtoField(e.target.value);
  }
  const handleLeadTypeChange = (e) => {
    setLeadtype(e.target.value);
  };
  const handleLeadSourceChange = (e) => {
    setLeadSource(e.target.value);
  };

  async function handleAvailability() {
    try {
      let available;

      if (isAvailable) {
        available = 0;
        setAvailableClass("unavailable");
      } else {
        available = 1;
        setAvailableClass("available");
      }
      setIsAvailable(!isAvailable);
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint

      const response = await axios.post(
        `${baseAPI}userpost/SetAvailability`,
        {
          is_availibility: available,
        }, // Send request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

    } catch (error) {
      console.error("Error posting data:", error);
    }
  }

  function nextPage(Relocation_ID) {
    const key = "dbbworldwidepvtltd";
    const encryptedRelocationID = encryptRelocationID(Relocation_ID, key);

    const url = `/ViewOrderDetails?Relocation_ID=${encryptedRelocationID}`;
    window.open(url, "_blank");
  }

  //pagination

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  // Add a null check using the optional chaining operator (?.)
  //const visibleData = userDetailResponse?.slice(startIndex, endIndex);

  // const handlePageChange = (newPage) => {
  //   setCurrentPage(newPage);
  // };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  // const handlePageSizeChange = (newPageSize) => {
  //   // if (newPageSize >= 1 && newPageSize <= totalPages) {
  //   //   setPageSize(newPageSize);
  //   // }

  // };

  async function deleteLead(relocationId) {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this record?"
    );
    if (isConfirmed) {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint
      const response = await axios.delete(
        `${baseAPI}userpost/DeleteRelocationId`,
        {
          data: { relocation_id: relocationId }, // Send request body
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      getLeadListButton();
    }
  }

  const sendDocumentMail = async (userEmail, relocation_id, index) => {
    setMailSent((prev) => [...prev, index]);
    const key = 'dbbworldwidepvtltd';
    const encryptedRelocationID = encryptRelocationID(relocation_id, key);
    const encryptedEmailID = encryptEmailID(userEmail, key);
    const userData = JSON.parse(localStorage.getItem("credentials"));
    const empEmail = userData ? userData.email : null;
    const documentObj = { CustEmail: userEmail, CustRelID: encryptedRelocationID, encryptedEmail: encryptedEmailID, relocationID: relocation_id, empEmail: empEmail };

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.post(
        `${baseAPI}userpost/SendDocumentUploadMail`,
        documentObj,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      toast.success("Mail sent successfully!", {
        position: "top-right",
        autoClose: 2000, // Auto close after 3 seconds
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      mailToggle(relocation_id)
    } catch (error) {
      console.error("Error posting data:", error);
    }
  }

  const mailToggle = async (relocation_id) => {
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.post(
        `${baseAPI}userpost/SendClientMailToggle`,
        { relocation_id },
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

    } catch (error) {
      console.error("Error posting data:", error);
    }
  }

  const handleAssignLOChange = (e) => {
    setAssignedtoLO(e.target.value);
  };

  function getEmployeeByDepartmentSales() {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(`${baseAPI}adminget/GETEmployeeByDepartment?department_id=3`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        setAssignToLOResponse(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  function getServiceType() {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(`${baseAPI}adminget/GetServiceType`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        setServiceTypeResponse(response.data.data);

      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  const handleServiceTypeChange = (e) => {
    setServiceType(e.target.value);
  };

  return (
    <>
      <div className="app-container-orderlist">
        <MiniDrawer />
        <div className="container-fluid container-orderlist">
          <div className="country-header">
            <div>
              <h1
                style={{
                  fontSize: "24px",
                  marginBottom: "1rem",
                  lineHeight: "1.7",
                }}
              >
                Order List| <HomeOutlinedIcon />{" "}
                <span style={{ fontSize: "20px" }}>&gt; Order List</span>
              </h1>
            </div>
            <div className="lead-list-button">
              <div
                className="unavalablel-orderlist"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                }}
              >
                <button onClick={handleAvailability} className={availableClass}>
                  {isAvailable ? "Available" : "Unavailable"}
                </button>
              </div>

              <div>
                <p
                  className="icon"
                  style={{
                    borderColor: "#C0C6CC",
                    border: "1px solid",
                    textAlign: "center",
                    padding: "10px",
                    fontSize: "13px",
                    width: "11rem",
                    height: "2.5rem",
                    borderRadius: "0.5rem",
                  }}
                >
                  {" "}
                  <b> Total Orders: </b>{" "}
                  <span style={{ color: "#5B489D" }}>
                    <b>{totalRecords}</b>
                  </span>
                </p>
              </div>
              {/* <div>
              <ExcelExport userDetailResponse={userDetailResponse} />
              </div> */}
            </div>
          </div>
          <wrapper className="wrapper orderlist">
            <div className="content-container-orderlist">
              <div className="container-fluid" styel={{ marginTop: "3rem" }}>
                <div style={{ display: "flex" }}>
                  <div
                    className=" headerButton"
                    style={{
                      display: "flex",
                      gap: "5px",
                      justifyContent: "left",
                      width: "82%",
                    }}
                  >
                    <div style={{ position: "relative", height: "3rem" }}>
                      <img
                        src={searchIcon}
                        alt="Search"
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "10px",
                          transform: "translateY(-50%)",
                          width: "16px",
                          height: "16px",
                          zIndex: 1,
                        }}
                      />

                      <input
                        type="text"
                        name="searchKeyword"
                        placeholder="Search"
                        value={searchKeyword}
                        onChange={handleSearchChange}
                        style={{
                          paddingLeft: "30px",
                          height: "2.5rem",
                          borderRadius: "0.5rem",
                          fontSize: "13px",
                          fontWeight: "bold",
                          marginTop: "6px",
                          position: "relative",
                          width: "10rem",
                        }}
                      />
                    </div>

                    <div>
                      <select
                        style={{
                          marginBottom: "1rem",
                          height: "2.5rem",
                          borderRadius: "0.5rem",
                          fontSize: "13px",
                          fontWeight: "bold",
                          marginTop: "6px",
                          width: "10rem",
                        }}
                        name="filterdata"
                        value={filterdata}
                        onChange={handleChange}
                      >
                        <option value="1"> Today's Task</option>
                        <option value="2">Today's Order</option>
                        <option value="3"> Today's Followup</option>
                        <option value="4">Missed Followup</option>
                        <option value="5"> Today's Update</option>
                        <option value="6">Total Order</option>
                        <option value="7">Total Untouched</option>
                        <option value="8">Total Open</option>
                        <option value="9"> Total Executed</option>
                        <option value="10">Total Cancelled</option>
                        <option value="11">Abandoned</option>
                      </select>
                    </div>
                    {/* <div>
                      <select
                        name="leadSource"
                        onChange={handleLeadSourceChange}
                        value={leadSource}
                        style={{
                          marginBottom: "1rem",
                          width: "7rem",
                          height: "2.5rem",
                          borderRadius: "0.5rem",
                          fontSize: "13px",
                          fontWeight: "bold",
                          marginTop: "6px",
                          width: "6.2rem",
                        }}
                      >
                        <option disabled value="0">
                          Lead Source
                        </option>
                        <option value="1">Web Query</option>
                        <option value="2">Email</option>
                        <option value="3">IVR</option>
                        <option value="4">Others</option>
                        <option value="99">All</option>
                      </select>
                    </div> */}
                    <div>
                      <select
                        name="leadtype"
                        onChange={handleLeadTypeChange}
                        value={leadtype}
                        style={{
                          marginBottom: "1rem",
                          width: "10rem",
                          height: "2.5rem",
                          borderRadius: "0.5rem",
                          fontSize: "13px",
                          fontWeight: "bold",
                          marginTop: "6px",
                        }}
                      >
                        <option disabled value="0">
                          Type
                        </option>
                        <option value="0">All</option>
                        <option value="Domestic">Domestic</option>
                        <option value="International">International</option>
                      </select>
                    </div>
                    <div>
                      <select
                        name="serviceType"
                        value={serviceType}
                        onChange={handleServiceTypeChange}
                        style={{
                          marginBottom: "1rem",
                          width: "10rem",
                          height: "2.5rem",
                          borderRadius: "0.5rem",
                          fontSize: "13px",
                          fontWeight: "bold",
                          marginTop: "6px",
                        }}
                      >
                        <option value="0">Service Type</option>
                        {serviceTypeResponse !== null ? (
                          serviceTypeResponse.map((item) => (
                            <option value={item.service_type}>
                              {item.ServiceTypeName}
                            </option>
                          ))
                        ) : (
                          <p>empty</p>
                        )}
                      </select>
                    </div>
                    <div>
                      <select
                        name="assignedtoLO"
                        onChange={handleAssignLOChange}
                        value={assignedtoLO}
                        style={{
                          marginBottom: "1rem",
                          width: "10rem",
                          height: "2.5rem",
                          borderRadius: "0.5rem",
                          fontSize: "13px",
                          fontWeight: "bold",
                          marginTop: "6px",
                        }}
                      >
                        <option disabled value="0">Lead Owner</option>
                        {assignToLOResponse.map((item) => (
                          <option value={item.customer_id} key={item.customer_id}>
                            {item.name}
                          </option>
                        ))}
                        <option value="All">All</option>
                      </select>
                    </div>


                    {isAdmin === "true" && (
                      <>
                        <div>
                          <select
                            name="assignedto"
                            onChange={handleAssignChange}
                            value={assignedto}
                            style={{
                              marginBottom: "1rem",
                              width: "10rem",
                              height: "2.5rem",
                              borderRadius: "0.5rem",
                              fontSize: "13px",
                              fontWeight: "bold",
                              marginTop: "6px",
                            }}
                          >
                            <option disabled value="0">
                              Ops Coordinator
                            </option>
                            {assignToResponse.map((item) => (
                              <option value={item.customer_id}>
                                {item.name}
                              </option>
                            ))}
                            <option value="All">All</option>
                          </select>
                        </div>
                        <div>
                          <select
                            name="assignedfieldto"
                            onChange={handleAssignField}
                            value={assignedfieldto}
                            style={{
                              marginBottom: "1rem",
                              width: "10rem",
                              height: "2.5rem",
                              borderRadius: "0.5rem",
                              fontSize: "13px",
                              fontWeight: "bold",
                              marginTop: "6px",

                            }}
                          >
                            <option disabled value="0">
                              Field Ops
                            </option>
                            {assignFieldResponse.map((item) => (
                              <option value={item.customer_id}>
                                {item.name}
                              </option>
                            ))}
                            <option value="All">All</option>
                          </select>
                        </div>
                      </>
                    )}

                    <div>
                      <button
                        style={{
                          marginBottom: "1rem",
                          width: "12rem",
                          height: "2.5rem",
                          borderRadius: "0.5rem",
                          fontSize: "13px",
                          marginTop: "6px",
                          width: "8rem",
                        }}
                        onClick={togglePicker}
                      >
                        {" "}
                        <b> {dateRange}</b>
                      </button>
                      {isOpen && (
                        <div
                          style={{
                            position: "absolute",
                            zIndex: 999,
                            border: "solid 1px black",
                            marginLeft: "-13pc",
                            width: "35pc",
                            background: "white",
                          }}
                        >
                          <DateRangePicker
                            ranges={[selectionRange]}
                            onChange={handleSelect}
                          />
                          <button
                            onClick={clearDateRange}
                            style={{
                              marginBottom: "1rem",
                              width: "5rem",
                              height: "2.5rem",
                              borderRadius: "0.5rem",
                              fontSize: "13px",
                              position: "relative",
                              top: "1px",
                              left: "22pc",
                              color: "red",
                              border: "none",
                            }}
                          >
                            Reset
                          </button>
                          <button
                            style={{
                              marginBottom: "1rem",
                              width: "7rem",
                              height: "2.5rem",
                              borderRadius: "0.5rem",
                              fontSize: "13px",
                              position: "relative",
                              top: "1px",
                              left: "22pc",
                              backgroundColor: "#5B489D",
                              color: "White",
                            }}
                            onClick={togglePicker}
                          >
                            Done
                          </button>
                        </div>
                      )}
                    </div>
                    <div>
                      <div
                        className="fafilterApply"
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        <div
                          className="orderlist-filter"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-end",
                            marginTop: "6px",
                            width: "8rem",
                          }}
                        >
                          <button onClick={getLeadListButton} className="">
                            Apply
                          </button>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div
                        className="fafilterresetApply"
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        <div
                          className="orderlist-filter-clear"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-end",
                            marginTop: "6px",
                            width: "8rem",
                            gap: "1px",
                          }}
                        >
                          {/* Clear Filter Button */}
                          <button
                            style={{
                              marginRight: "34px",
                              fontWeight: "600",
                              color: "#F15843",
                            }}
                            onClick={clearFilter}
                            className=""
                          >
                            Clear Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </wrapper>
          <br />
          <div>
            <div className="sscroll">
              <Wrapper className="orderlist">
                <div className="content-container-orderlist">
                  {loading ? (
                    <Loader /> // Display the loader while data is being fetched
                  ) : (
                    <div className="container-fluid" style={{ width: "auto" }}>
                      <div>

                        <table className="orderlist" style={{ width: "100%" }}>
                          <tr className="orderlistHeading">
                            <th style={{ width: "2%" }}>Sr.No.</th>
                            <th style={{ width: "22%" }}>Order Details</th>
                            <th style={{ width: "15%" }}>Pet Details</th>
                            <th style={{ width: "18%" }}>Customer Details</th>
                            <th style={{ width: "22%" }}>Order Updates</th>
                            <th style={{ width: "17%" }}>Remark</th>
                            <th style={{ width: "2%" }}>Details</th>
                            <th style={{ width: "2%" }}>Send Mail</th>
                          </tr>
                          {userDetailResponse?.length > 0 ? (
                            userDetailResponse.map((user, index) => (
                              <tr>
                                <td>
                                  {++index}
                                </td>
                                <td>
                                  <table
                                    className="orderlist_1"
                                    style={{ verticalAlign: "top" }}
                                  >
                                    <tr style={{ paddingBottom: "1rem" }}>
                                      <td
                                        style={{
                                          width: "40%",
                                          fontWeight: "bold",
                                          color: "#6A6A6A",
                                        }}
                                      >
                                        Booking Date
                                      </td>
                                      <td style={{ width: "4%" }}>:</td>
                                      <td
                                        style={{
                                          width: "55%",
                                          color: "#6A6A6A",
                                        }}
                                      >
                                        {user.createdDate}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        style={{
                                          fontWeight: "bold",
                                          color: "#6A6A6A",
                                        }}
                                      >
                                        Relocation Date
                                      </td>
                                      <td>:</td>
                                      {/*---- Add--Relocation date---*/}
                                      <td style={{ color: "#6A6A6A" }}>
                                        {user.Relocation_Date}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        style={{
                                          fontWeight: "bold",
                                          color: "#6A6A6A",
                                        }}
                                      >
                                        Service Type
                                      </td>
                                      <td>:</td>
                                      {/* Service type*/}
                                      <td style={{ color: "#6A6A6A" }}>
                                        {user.ServiceTypeName}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        style={{
                                          fontWeight: "bold",
                                          color: "#6A6A6A",
                                        }}
                                      >
                                        Delivery Type
                                      </td>
                                      <td>:</td>
                                      <td style={{ color: "#6A6A6A" }}>
                                        {user.Delivery_Type_Name1}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        style={{
                                          fontWeight: "bold",
                                          color: "#6A6A6A",
                                        }}
                                      >
                                        Origin
                                      </td>
                                      <td>:</td>
                                      <td style={{ color: "#6A6A6A" }}>
                                        {user.Origin_Country1}{" , "}
                                        {user.Origin_State1}{" , "}
                                        {user.Origin_City1}
                                      </td>
                                      {/* <td>{user.next_follow_up}</td> */}
                                    </tr>
                                    <tr>
                                      <td
                                        style={{
                                          fontWeight: "bold",
                                          color: "#6A6A6A",
                                        }}
                                      >
                                        Destination
                                      </td>
                                      <td>:</td>
                                      <td style={{ color: "#6A6A6A" }}>
                                        {user.Destination_Country1}{" , "}
                                        {user.Destination_State1}{" , "}
                                        {user.Destination_City1}
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                                <td>
                                  <table className="orderlist_1">
                                    <tr>
                                      <td
                                        style={{
                                          fontWeight: "bold",
                                          color: "#6A6A6A",
                                        }}
                                      >
                                        Pet Name
                                      </td>
                                      <td>:</td>
                                      <td style={{ color: "#6A6A6A" }}>
                                        {user.Pet_Firstname1}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        style={{
                                          width: "40%",
                                          fontWeight: "bold",
                                          color: "#6A6A6A",
                                        }}
                                      >
                                        No. of Pet
                                      </td>
                                      <td style={{ width: "4%" }}>:</td>
                                      <td
                                        style={{
                                          width: "55%",
                                          color: "#6A6A6A",
                                        }}
                                      >
                                        {user.Number_Of_Pets}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        style={{
                                          fontWeight: "bold",
                                          color: "#6A6A6A",
                                        }}
                                      >
                                        Pet Type
                                      </td>
                                      <td>:</td>
                                      <td style={{ color: "#6A6A6A" }}>
                                        {user.petType}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        style={{
                                          fontWeight: "bold",
                                          color: "#6A6A6A",
                                        }}
                                      >
                                        Pet Breed
                                      </td>
                                      <td>:</td>
                                      <td style={{ color: "#6A6A6A" }}>
                                        {user.PetBreedType}
                                      </td>
                                    </tr>

                                    <tr>
                                      <td
                                        style={{
                                          fontWeight: "bold",
                                          color: "#6A6A6A",
                                        }}
                                      >
                                        Pet DOB
                                      </td>
                                      <td>:</td>
                                      <td style={{ color: "#6A6A6A" }}>
                                        {user.Pet_DOB}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        style={{
                                          fontWeight: "bold",
                                          color: "#6A6A6A",
                                        }}
                                      >
                                        Crate Size
                                      </td>
                                      <td>:</td>
                                      <td style={{ color: "#6A6A6A" }}>
                                        32 inches
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                                <td>
                                  <table className="orderlist_1">
                                    <tr>
                                      <td
                                        style={{
                                          fontWeight: "bold",
                                          color: "#6A6A6A",
                                        }}
                                      >
                                        Lead ID
                                      </td>
                                      <td>:</td>
                                      <td style={{ color: "#6A6A6A" }}>
                                        {" "}
                                        {user.Relocation_ID}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        style={{
                                          fontWeight: "bold",
                                          color: "#6A6A6A",
                                        }}
                                      >
                                        Name
                                      </td>
                                      <td>:</td>

                                      <td style={{ color: "#6A6A6A" }}>
                                        {user.First_Name} {user.Last_Name}
                                      </td>
                                    </tr>

                                    <tr>
                                      <td
                                        style={{
                                          fontWeight: "bold",
                                          color: "#6A6A6A",
                                        }}
                                      >
                                        Email
                                      </td>
                                      <td>:</td>
                                      <td style={{ color: "#6A6A6A" }}>
                                        {user.Email}
                                      </td>
                                    </tr>

                                    <tr>
                                      <td
                                        style={{
                                          fontWeight: "bold",
                                          color: "#6A6A6A",
                                        }}
                                      >
                                        Phone
                                      </td>
                                      <td>:</td>
                                      <td style={{ color: "#6A6A6A" }}>
                                        {user.Mobile_No}
                                      </td>
                                    </tr>

                                    <tr>
                                      <td
                                        style={{
                                          fontWeight: "bold",
                                          color: "#6A6A6A",
                                        }}
                                      >
                                        Payment Status
                                      </td>
                                      <td>:</td>
                                      <td style={{ color: "#6A6A6A" }}>
                                        {user.Payment_status} ({user.Payment_Ter ?? 0}%)
                                      </td>
                                    </tr>

                                    <tr>
                                      <td
                                        style={{
                                          fontWeight: "bold",
                                          color: "#6A6A6A",
                                        }}
                                      >
                                        Booking Status
                                      </td>
                                      <td>:</td>
                                      <td>
                                        <b
                                          style={{
                                            height: "30px",
                                            width: "100px",
                                            color: "white",
                                            fontWeight: "bold",
                                            textAlign: "center",
                                            padding: "6px",
                                            borderRadius: "15px",
                                            backgroundColor: getStatusColor(user.status_name),
                                          }}
                                        >
                                          {" "}
                                          {user.status_name}{" "}
                                        </b>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                                <td>
                                  <table className="orderlist_1">
                                    <tr>
                                      <td
                                        style={{
                                          fontWeight: "bold",
                                          color: "#6A6A6A",
                                        }}
                                      >
                                        Last Update
                                      </td>
                                      <td>:</td>
                                      <td style={{ color: "#6A6A6A" }}>
                                        {user.modified_date}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        style={{
                                          fontWeight: "bold",
                                          color: "#6A6A6A",
                                        }}
                                      >
                                        No. of Follow Ups
                                      </td>
                                      <td>:</td>
                                      <td style={{ color: "#6A6A6A" }}>
                                        {user.total_followups}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        style={{
                                          fontWeight: "bold",
                                          color: "#6A6A6A",
                                        }}
                                      >
                                        Follow Up Time
                                      </td>
                                      <td>:</td>
                                      <td style={{ color: "#6A6A6A" }}>
                                        {user.followUpTime1}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        style={{
                                          fontWeight: "bold",
                                          color: "#6A6A6A",
                                        }}
                                      >
                                        Follow Up Date
                                      </td>
                                      <td>:</td>
                                      <td style={{ color: "#6A6A6A" }}>
                                        {user.followUpDate1}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        style={{
                                          fontWeight: "bold",
                                          color: "#6A6A6A",
                                        }}
                                      >
                                        Sales Coordinator
                                      </td>
                                      <td>:</td>
                                      <td style={{ color: "#6A6A6A" }}>
                                        {user.lead_owner}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        style={{
                                          fontWeight: "bold",
                                          color: "#6A6A6A",
                                        }}
                                      >
                                        Ops Coordinator
                                      </td>
                                      <td>:</td>
                                      <td style={{ color: "#6A6A6A" }}>
                                        {user.Assigned_By_Coordinator}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        style={{
                                          fontWeight: "bold",
                                          color: "#6A6A6A",
                                        }}
                                      >
                                        Field Coordinator
                                      </td>
                                      <td>:</td>
                                      <td style={{ color: "#6A6A6A" }}>
                                        {user.Assigned_To_FieldOps}
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                                <td>
                                  <table className="orderlist_1">
                                    <tr>
                                      <td style={{ fontWeight: "bold" }}></td>

                                      <td>
                                        <p style={{ color: "#6A6A6A" }}>
                                          {user.last_followup_remark}
                                        </p>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                                <td>
                                  <button
                                    onClick={() => nextPage(user.Relocation_ID)}
                                    style={{
                                      height: "1px",
                                      width: "1px",
                                      backgroundColor: "white",
                                      alignItems: "center",
                                      border: "none",
                                      marginTop: "6rem",
                                      marginLeft: "0.5rem",
                                    }}
                                  >
                                    <img src={search} alt="search" />
                                  </button>
                                </td>
                                <td>
                                  <Tooltip title="sendMail">
                                    <button onClick={() => sendDocumentMail(user.Email, user.Relocation_ID, index)}

                                      style={{
                                        width: "56px", border: "none", marginTop: "5.5rem",
                                        color: user.sendMail === 1 ? "red" : "green"
                                      }}>
                                      <MailIcon style={{ height: "36px", width: "36px", marginLeft: "-3px", marginTop: "-1px" }} className="icon" />

                                    </button>
                                  </Tooltip>
                                </td>
                                <ToastContainer />
                              </tr>
                            ))
                          ) : (
                            <p>empty</p>
                          )}
                        </table>
                        <nav
                          aria-label="Page navigation"
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginTop: "1rem",
                          }}
                        >
                          <ul className="pagination">
                            <li className="page-item">
                              <a
                                style={{ cursor: "pointer" }}
                                className="page-link"
                                onClick={() => {
                                  handlePageChange(currentPage - 1);
                                }}
                                disabled={currentPage === 1}
                              >
                                Previous
                              </a>
                            </li>
                            <li className="page-item">
                              <a
                                style={{ cursor: "pointer" }}
                                className="page-link"
                                onClick={() => {
                                  handlePageChange(currentPage - 1);
                                }}
                                disabled={currentPage === 1}
                              >
                                {currentPage - 1}
                              </a>
                            </li>
                            <li className="page-item active">
                              <a className="page-link">{currentPage}</a>
                            </li>
                            <li className="page-item">
                              <a
                                style={{ cursor: "pointer" }}
                                className="page-link"
                                onClick={() => {
                                  handlePageChange(currentPage + 1);
                                }}
                                disabled={
                                  endIndex >= userDetailResponse?.length
                                }
                              >
                                {currentPage + 1}
                              </a>
                            </li>
                            <li className="page-item">
                              <a
                                style={{ cursor: "pointer" }}
                                className="page-link"
                                onClick={() => {
                                  handlePageChange(currentPage + 1);
                                }}
                                disabled={
                                  endIndex >= userDetailResponse?.length
                                }
                              >
                                Next
                              </a>
                            </li>
                          </ul>

                          {/* <ul className="pagination">
                            <li className="page-item">
                              <a
                                style={{ cursor: "pointer" }}
                                className="page-link"
                                onClick={() => { handlePageChange(currentPage - 1); }}
                                disabled={currentPage === 1}
                              >
                                Previous
                              </a>
                            </li>

                            
                            {[...Array(totalPages)].map((_, index) => {
                              const pageNumber = index + 1;
                              return (
                                <li key={pageNumber} className={`page-item ${pageNumber === currentPage ? 'active' : ''}`}>
                                  <a
                                    style={{ cursor: "pointer" }}
                                    className="page-link"
                                    onClick={() => { handlePageChange(pageNumber); }}
                                  >
                                    {pageNumber}
                                  </a>
                                </li>
                              );
                            })}

                            <li className="page-item">
                              <a
                                style={{ cursor: "pointer" }}
                                className="page-link"
                                onClick={() => { handlePageChange(currentPage + 1); }}
                                disabled={currentPage === totalPages}
                              >
                                Next
                              </a>
                            </li>
                          </ul> */}
                        </nav>
                      </div>
                    </div>
                  )}
                </div>
              </Wrapper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderList;
